import React, { useState } from "react";
import { HStack } from "@design-system/HStack/HStack";
import { HOTKEYS_SCOPES } from "@hooks/keyboard/useKeyboardCommand";
import { useCanPerformWorkspaceAction } from "@hooks/permissions/useCanPerformWorkspaceAction";
import { useActiveWorkspace } from "@hooks/useActiveWorkspace";
import { useEntities } from "@hooks/useEntities";
import { useActiveWorkspaceRole } from "@hooks/permissions/useActiveWorkspaceRole";
import { WorkspaceAction } from "@common/userWorkspaceRoles";
import { useOverlays } from "contexts/OverlayContext";
import { TablePageHeader } from "../../pageHeader/TablePageHeader";
import { WorkspaceMemberList } from "./WorkspaceMemberList";
import { Button } from "@design-system/Button/Button";
import { WithHotkey } from "@design-system/Button/WithHotkey";

export const WorkspaceMembers: React.FC = () => {
    const [search, setSearch] = useState("");
    const { openOverlay } = useOverlays();
    const canAddMember = useCanPerformWorkspaceAction(
        WorkspaceAction.MEMBERS_EDIT,
    );
    const activeWorkspace = useActiveWorkspace();
    const actingUserRole = useActiveWorkspaceRole();
    const entities = useEntities({
        requireAdminAccess: true,
        excludeMockEntities: true,
    });

    return (
        <main>
            <HStack as="header" align="start" className="settings__header">
                <h3 className="settings__heading">Members</h3>
            </HStack>

            <TablePageHeader search={search} onSearchChange={setSearch}>
                {canAddMember && (
                    <WithHotkey
                        hotKey="alt+n"
                        hotKeyOptions={{
                            description: "Add member",
                            scopes: [HOTKEYS_SCOPES.SETTINGS_MODAL],
                            preventDefault: true,
                        }}
                    >
                        <Button
                            variant="primary"
                            size="md"
                            onClick={() =>
                                openOverlay("memberManagementAddMember", {
                                    workspaceId: activeWorkspace?.id,
                                    actingUserRole: actingUserRole ?? undefined,
                                    entities,
                                })
                            }
                            disabled={!activeWorkspace || !actingUserRole}
                        >
                            Add member
                        </Button>
                    </WithHotkey>
                )}
            </TablePageHeader>

            <WorkspaceMemberList search={search} />
        </main>
    );
};
